import React from "react";
import { Select, SelectItem } from "@nextui-org/select";
import { IoChevronDownSharp } from "react-icons/io5";

const select = ({
  values,
  options,
  label,
  value,
  placeholder,
  setValue,
  error,
  disabled,
}: any) => {
  const onChange = (e: any) => {
    setValue(e.target.value);
  };
  return (
    <div className="flex flex-col relative select-none">
      <label className="text-base mb-2">{label}</label>
      <Select
        isDisabled={disabled}
        placeholder={placeholder}
        aria-label="select enterprise size"
        className="max-w-full"
        radius="full"
        size="md"
        variant="flat"
        onChange={onChange}
        defaultSelectedKeys={[value]}
        selectorIcon={<IoChevronDownSharp color="black" />}
      >
        {values.map((value: any, index: number) => (
          <SelectItem key={value} className="text-black bg-white">
            {options[index]}
          </SelectItem>
        ))}
      </Select>
      {error && (
        <small className="text-red-500 absolute -bottom-5 left-0">
          {error}
        </small>
      )}
    </div>
  );
};

export default select;
